import {Country} from "../../../api/generated";
import {SelectOption} from "../../elements/select/SelectDropdown";

export const DEFAULT_SUPPORTED_PHONE_NUMBER_LOCALES: Country[] = [
    Country.Gb,
    Country.Ie,
    Country.Ca
];

export const allSupportedPhoneLocaleOptions: SelectOption<Country>[] = [
    {label: "United Kingdom (GB)", value: Country.Gb},
    {label: "Ireland (IE)", value: Country.Ie},
    {label: "Canada (CA)", value: Country.Ca},
    {label: "United States (US)", value: Country.Us},
    {label: "France (FR)", value: Country.Fr}
];

export const getSupportedPhoneLocaleLabel = (country: Country): string => {
    const found = allSupportedPhoneLocaleOptions.find(option => option.value === country);
    return found?.label ?? country;
};
